import React, { useState, useEffect } from 'react';
import WaitlistSourceDialog from '@/components/WaitlistSourceDialog';

// Error terminal content - shows compilation errors
const ErrorTerminalContent = () => {
    return (
        <div className="font-mono text-[13px] leading-[1.6] p-4">
            {/* Error messages */}
            <div className="flex">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>1</span>
                <span style={{ color: '#f44747' }}>error</span>
                <span style={{ color: '#d4d4d4' }}> TS2307: Cannot find module </span>
                <span style={{ color: '#ce9178' }}>'razorpay'</span>
            </div>
            <div className="flex">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>2</span>
                <span style={{ color: '#d4d4d4' }}>  → No matching export in </span>
                <span style={{ color: '#ce9178' }}>'node_modules'</span>
            </div>
            <div className="flex mt-2">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>3</span>
                <span style={{ color: '#f44747' }}>error</span>
                <span style={{ color: '#d4d4d4' }}> TS2339: Property </span>
                <span style={{ color: '#ce9178' }}>'createOrder'</span>
                <span style={{ color: '#d4d4d4' }}> does not exist</span>
            </div>
            <div className="flex">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>4</span>
                <span style={{ color: '#d4d4d4' }}>  → on type </span>
                <span style={{ color: '#4ec9b0' }}>'PaymentGateway'</span>
            </div>
            <div className="flex mt-2">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>5</span>
                <span style={{ color: '#f44747' }}>error</span>
                <span style={{ color: '#d4d4d4' }}> TS2345: Argument of type </span>
                <span style={{ color: '#ce9178' }}>'string'</span>
            </div>
            <div className="flex">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>6</span>
                <span style={{ color: '#d4d4d4' }}>  → is not assignable to </span>
                <span style={{ color: '#4ec9b0' }}>'PaymentOptions'</span>
            </div>
            <div className="flex mt-2">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>7</span>
                <span style={{ color: '#f44747' }}>error</span>
                <span style={{ color: '#d4d4d4' }}> TS7006: Parameter </span>
                <span style={{ color: '#ce9178' }}>'response'</span>
                <span style={{ color: '#d4d4d4' }}> implicitly has </span>
                <span style={{ color: '#ce9178' }}>'any'</span>
                <span style={{ color: '#d4d4d4' }}> type</span>
            </div>
            <div className="flex mt-3">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}></span>
                <span style={{ color: '#f44747', fontWeight: 'bold' }}>✗ Failed to compile</span>
            </div>
            <div className="flex">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}></span>
                <span style={{ color: '#858585' }}>4 errors found in payments.ts</span>
            </div>
        </div>
    );
};

// Static installing content - shows installation in progress (reversible, no animation state)
const InstallingTerminalContent = () => {
    return (
        <div className="font-mono text-[13px] leading-[1.6] p-4">
            {/* Installing header */}
            <div className="flex">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>$</span>
                <span style={{ color: '#4fc1ff' }}>pluckr</span>
                <span style={{ color: '#d4d4d4' }}> install </span>
                <span style={{ color: '#ce9178' }}>@pluckr/payments</span>
            </div>
            <div className="flex mt-2">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}></span>
                <span style={{ color: '#858585' }}>Resolving dependencies...</span>
            </div>
            <div className="flex">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}></span>
                <span style={{ color: '#dcdcaa' }}>✓</span>
                <span style={{ color: '#858585' }}> Found verified MCP package</span>
            </div>
            <div className="flex mt-2">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}></span>
                <span style={{ color: '#569cd6' }}>⠋</span>
                <span style={{ color: '#d4d4d4' }}> Installing @pluckr/payments@1.2.3...</span>
            </div>
            <div className="flex">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}></span>
                <span style={{ color: '#569cd6' }}>⠙</span>
                <span style={{ color: '#858585' }}> Configuring Razorpay adapter...</span>
            </div>
            <div className="flex">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}></span>
                <span style={{ color: '#569cd6' }}>⠹</span>
                <span style={{ color: '#858585' }}> Generating type definitions...</span>
            </div>
            <div className="flex mt-3">
                <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}></span>
                <span style={{ color: '#dcdcaa', fontWeight: 'bold' }}>▓▓▓▓▓▓▓▓▓▓▓▓▓▓░░░░░░</span>
                <span style={{ color: '#858585' }}> 70%</span>
            </div>
        </div>
    );
};

// Typing animation for success code
const TypingCodeContent = ({ onComplete }) => {
    const [visibleLines, setVisibleLines] = useState(0);
    const [showSuccess, setShowSuccess] = useState(false);

    const codeLines = [
        { content: [{ text: 'import', type: 'keyword' }, { text: ' { PluckrPayments } ', type: 'default' }, { text: 'from', type: 'keyword' }, { text: ' ', type: 'default' }, { text: '"@pluckr/payments"', type: 'string' }] },
        { content: [] },
        { content: [{ text: 'const', type: 'keyword' }, { text: ' payments = ', type: 'default' }, { text: 'new', type: 'keyword' }, { text: ' PluckrPayments()', type: 'function' }] },
        { content: [] },
        { content: [{ text: 'export', type: 'keyword' }, { text: ' ', type: 'default' }, { text: 'async', type: 'keyword' }, { text: ' ', type: 'default' }, { text: 'function', type: 'keyword' }, { text: ' ', type: 'default' }, { text: 'processPayment', type: 'function' }, { text: '(amount) {', type: 'punctuation' }] },
        { content: [{ text: '  ', type: 'default' }, { text: 'const', type: 'keyword' }, { text: ' order = ', type: 'default' }, { text: 'await', type: 'keyword' }, { text: ' payments.createOrder({', type: 'default' }] },
        { content: [{ text: '    amount,', type: 'default' }] },
        { content: [{ text: '    currency: ', type: 'default' }, { text: '"INR"', type: 'string' }, { text: ',', type: 'default' }] },
        { content: [{ text: '    gateway: ', type: 'default' }, { text: '"razorpay"', type: 'string' }] },
        { content: [{ text: '  })', type: 'default' }] },
        { content: [{ text: '  ', type: 'default' }, { text: 'return', type: 'keyword' }, { text: ' order', type: 'default' }] },
        { content: [{ text: '}', type: 'punctuation' }] },
    ];

    const getColor = (type) => {
        const colors = {
            string: '#ce9178',
            keyword: '#c586c0',
            function: '#dcdcaa',
            tag: '#569cd6',
            component: '#4ec9b0',
            attribute: '#9cdcfe',
            punctuation: '#d4d4d4',
            default: '#d4d4d4',
        };
        return colors[type] || colors.default;
    };

    useEffect(() => {
        if (visibleLines < codeLines.length) {
            const timer = setTimeout(() => {
                setVisibleLines(prev => prev + 1);
            }, 120);
            return () => clearTimeout(timer);
        } else {
            // Show success message after code is done
            const successTimer = setTimeout(() => {
                setShowSuccess(true);
                onComplete?.();
            }, 300);
            return () => clearTimeout(successTimer);
        }
    }, [visibleLines, codeLines.length, onComplete]);

    return (
        <div className="font-mono text-[13px] leading-[1.6] p-4">
            {codeLines.slice(0, visibleLines).map((line, idx) => (
                <div key={idx} className="flex">
                    <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>
                        {idx + 1}
                    </span>
                    <span>
                        {line.content.length === 0 ? (
                            <span>&nbsp;</span>
                        ) : (
                            line.content.map((token, i) => (
                                <span key={i} style={{ color: getColor(token.type) }}>
                                    {token.text}
                                </span>
                            ))
                        )}
                    </span>
                </div>
            ))}

            {/* Typing cursor */}
            {visibleLines < codeLines.length && (
                <div className="flex">
                    <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>
                        {visibleLines + 1}
                    </span>
                    <span
                        style={{
                            backgroundColor: '#d4d4d4',
                            width: '8px',
                            height: '16px',
                            animation: 'typing-cursor 1s step-end infinite'
                        }}
                    />
                </div>
            )}

            {/* Success message */}
            {showSuccess && (
                <div className="mt-4 pt-3" style={{ borderTop: '1px solid #333' }}>
                    <div className="flex items-center gap-2">
                        <span style={{ color: '#00ff88', fontWeight: 'bold' }}>✓</span>
                        <span style={{ color: '#00ff88', fontWeight: 'bold' }}>Compiled successfully!</span>
                    </div>
                    <div className="flex mt-1">
                        <span style={{ color: '#858585' }}>No errors or warnings</span>
                    </div>
                    <div className="flex mt-2">
                        <span style={{ color: '#00ff88' }}>→ Ready for production</span>
                    </div>
                </div>
            )}
        </div>
    );
};

// Character-by-character typewriter effect for success code
const TypewriterSuccessContent = () => {
    const [charIndex, setCharIndex] = useState(0);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);

    const codeLines = [
        { content: [{ text: 'import', type: 'keyword' }, { text: ' { PluckrPayments } ', type: 'default' }, { text: 'from', type: 'keyword' }, { text: ' ', type: 'default' }, { text: '"@pluckr/payments"', type: 'string' }] },
        { content: [] },
        { content: [{ text: 'const', type: 'keyword' }, { text: ' payments = ', type: 'default' }, { text: 'new', type: 'keyword' }, { text: ' PluckrPayments()', type: 'function' }] },
        { content: [] },
        { content: [{ text: 'export', type: 'keyword' }, { text: ' ', type: 'default' }, { text: 'async', type: 'keyword' }, { text: ' ', type: 'default' }, { text: 'function', type: 'keyword' }, { text: ' ', type: 'default' }, { text: 'processPayment', type: 'function' }, { text: '(amount) {', type: 'punctuation' }] },
        { content: [{ text: '  ', type: 'default' }, { text: 'const', type: 'keyword' }, { text: ' order = ', type: 'default' }, { text: 'await', type: 'keyword' }, { text: ' payments.createOrder({', type: 'default' }] },
        { content: [{ text: '    amount,', type: 'default' }] },
        { content: [{ text: '    currency: ', type: 'default' }, { text: '"INR"', type: 'string' }, { text: ',', type: 'default' }] },
        { content: [{ text: '    gateway: ', type: 'default' }, { text: '"razorpay"', type: 'string' }] },
        { content: [{ text: '  })', type: 'default' }] },
        { content: [{ text: '  ', type: 'default' }, { text: 'return', type: 'keyword' }, { text: ' order', type: 'default' }] },
        { content: [{ text: '}', type: 'punctuation' }] },
    ];

    // Calculate total characters
    const totalChars = codeLines.reduce((acc, line) => {
        const lineChars = line.content.reduce((lAcc, token) => lAcc + token.text.length, 0);
        return acc + lineChars; // Newlines are implicit in map structure, but we can ignore counting them for simplicity or treat each line end as a pause? 
        // For simplicity, just count visible text characters.
    }, 0);

    useEffect(() => {
        if (charIndex < totalChars) {
            const timeout = setTimeout(() => {
                setCharIndex(prev => prev + 1);
            }, 8); // Fast typing speed (8ms per char)
            return () => clearTimeout(timeout);
        } else {
            // Animation complete, show success message shortly after
            const msgTimeout = setTimeout(() => {
                setShowSuccessMsg(true);
            }, 300);
            return () => clearTimeout(msgTimeout);
        }
    }, [charIndex, totalChars]);

    const getColor = (type) => {
        const colors = {
            string: '#ce9178',
            keyword: '#c586c0',
            function: '#dcdcaa',
            punctuation: '#d4d4d4',
            default: '#d4d4d4',
        };
        return colors[type] || colors.default;
    };

    // Render logic to slice tokens based on charIndex
    let charsRendered = 0;

    return (
        <div className="font-mono text-[13px] leading-[1.6] p-4">
            {codeLines.map((line, idx) => {
                const isLineVisible = charsRendered <= charIndex;
                if (!isLineVisible) return null; // Optimization? Or maybe preserve height? 
                // Better to render empty divs to preserve layout if needed, but for typewriter growing down is fine.

                return (
                    <div key={idx} className="flex min-h-[21px]">
                        <span className="w-8 text-right pr-4 select-none" style={{ color: '#858585' }}>
                            {charsRendered < charIndex ? idx + 1 : ''}
                        </span>
                        <span>
                            {line.content.map((token, i) => {
                                if (charsRendered >= charIndex) return null;

                                const tokenStart = charsRendered;
                                const tokenEnd = tokenStart + token.text.length;

                                let textToShow = token.text;
                                if (charIndex < tokenEnd) {
                                    textToShow = token.text.substring(0, charIndex - tokenStart);
                                }

                                charsRendered += token.text.length;

                                return (
                                    <span key={i} style={{ color: getColor(token.type) }}>
                                        {textToShow}
                                    </span>
                                );
                            })}
                        </span>
                        {/* Cursor at current line end if active */}
                        {/* Logic for cursor placement is complex across restricted tokens. 
                            Simplified: Just append cursor to the last rendered element? 
                            Or just floating cursor at bottom?
                        */}
                    </div>
                );
            })}

            {/* Blinking cursor at the end of content */}
            {!showSuccessMsg && (
                <div className="inline-block w-2.5 h-4 bg-gray-400 align-middle animate-pulse ml-1" style={{ marginTop: '-4px' }} />
            )}

            {showSuccessMsg && (
                <div className="mt-4 pt-3 animate-in fade-in slide-in-from-bottom-2 duration-500" style={{ borderTop: '1px solid #333' }}>
                    <div className="flex items-center gap-2">
                        <span style={{ color: '#00ff88', fontWeight: 'bold' }}>✓</span>
                        <span style={{ color: '#00ff88', fontWeight: 'bold' }}>Compiled successfully!</span>
                    </div>
                    <div className="flex mt-1">
                        <span style={{ color: '#858585' }}>No errors or warnings</span>
                    </div>
                    <div className="flex mt-2">
                        <span style={{ color: '#00ff88' }}>→ Ready for production</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export const HeroSection2 = ({ terminalState = 'error' }) => {
    // Terminal state is now fully driven by scroll progress prop - no internal state needed
    // This enables full reversibility: scroll up reverts to previous states instantly

    const [email, setEmail] = useState('');
    const [waitlistSubmitted, setWaitlistSubmitted] = useState(false);
    const [isSourceDialogOpen, setIsSourceDialogOpen] = useState(false);
    const [sourceStatus, setSourceStatus] = useState('idle'); // idle | loading | success | already
    const [selectedSource, setSelectedSource] = useState(null);
    const [pendingEmail, setPendingEmail] = useState('');
    const [waitlistError, setWaitlistError] = useState('');
    const [resultMessage, setResultMessage] = useState('');
    const [waitlistCount, setWaitlistCount] = useState(null);

    const API_URL =
        process.env.REACT_APP_BACKEND_URL ||
        (process.env.NODE_ENV === 'development'
            ? 'http://localhost:5000'
            : 'https://api.pluckr.ai');

    useEffect(() => {
        let cancelled = false;

        const loadCount = async () => {
            try {
                const candidates = [
                    `${API_URL}/api/waitlist/count`,
                    '/api/waitlist/count',
                    'http://localhost:5000/api/waitlist/count',
                    'https://api.pluckr.ai/api/waitlist/count',
                ];

                const seen = new Set();
                const urls = candidates.filter((u) => {
                    if (!u || seen.has(u)) return false;
                    seen.add(u);
                    return true;
                });

                for (const url of urls) {
                    if (cancelled) return;

                    const controller = new AbortController();
                    const timeout = setTimeout(() => controller.abort(), 2500);

                    try {
                        const response = await fetch(url, {
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json' },
                            signal: controller.signal,
                        });

                        if (!response.ok) continue;

                        const payload = await response.json().catch(() => ({}));
                        const rawCount = payload?.data?.count;
                        const count = typeof rawCount === 'number' ? rawCount : Number(rawCount);

                        if (!cancelled && Number.isFinite(count)) {
                            setWaitlistCount(count);
                            return;
                        }
                    } catch {
                        // try next candidate
                    } finally {
                        clearTimeout(timeout);
                    }
                }
            } catch {
                // No-op: count is optional UI sugar.
            }
        };

        loadCount();
        return () => {
            cancelled = true;
        };
    }, [API_URL]);

    const handleWaitlistSubmit = (e) => {
        e.preventDefault();
        setWaitlistError('');
        setResultMessage('');
        setPendingEmail(email);
        setSelectedSource(null);
        setSourceStatus('idle');
        setIsSourceDialogOpen(true);
    };

    const submitWaitlist = async (source) => {
        // Optimistic UX: show thanks immediately, let backend email send async.
        setSelectedSource(source);
        setSourceStatus('success');
        setResultMessage("You're on the waitlist. We'll inform you soon.");
        setWaitlistError('');

        try {

            const response = await fetch(`${API_URL}/api/waitlist/join`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: pendingEmail, source }),
            });

            const payload = await response.json().catch(() => ({}));
            if (!response.ok || payload?.success === false) {
                throw new Error(payload?.message || 'Failed to join waitlist');
            }

            if (payload?.alreadyJoined) {
                setSourceStatus('already');
                setResultMessage(
                    payload?.message ||
                    "We get it — you can't wait. We'll get back to you real quick."
                );
            } else {
                setSourceStatus('success');
                setResultMessage(payload?.message || "You're on the waitlist. We'll inform you soon.");
            }

            setWaitlistSubmitted(true);
            setEmail('');
            setPendingEmail('');
        } catch (err) {
            // Revert optimistic success on hard failure.
            setSourceStatus('idle');
            setResultMessage('');
            setWaitlistError(err?.message || 'Could not join waitlist. Please try again.');
        }
    };

    return (
        <section
            id="join-waitlist"
            className="min-h-screen w-full relative overflow-hidden py-20 bg-[#fafaf8] dark:bg-[var(--pluckr-bg)]"
            data-testid="hero-section-2"
        >
            <WaitlistSourceDialog
                open={isSourceDialogOpen}
                onOpenChange={(open) => {
                    setIsSourceDialogOpen(open);
                }}
                onSelect={setSelectedSource}
                onSubmit={submitWaitlist}
                status={sourceStatus}
                selected={selectedSource}
                resultMessage={resultMessage}
            />

            {/* Two-panel editorial container */}
            <div className="max-w-[1400px] mx-auto px-6 lg:px-16 h-full">
                <div
                    className="flex rounded-[24px] overflow-hidden"
                    style={{
                        minHeight: '75vh',
                        boxShadow: '0 4px 40px rgba(0, 0, 0, 0.06)'
                    }}
                >
                    {/* Left Panel - Laptop Area */}
                    <div
                        className="w-1/2 flex items-center justify-center p-12 lg:p-16 bg-[#ebe9e1] dark:bg-[var(--pluckr-bg-terminal)]"
                    >
                        {/* MacBook-style Editor Window */}
                        <div
                            className="w-full max-w-[580px] rounded-xl overflow-hidden flex flex-col"
                            data-testid="laptop-terminal"
                            style={{
                                boxShadow: terminalState === 'error'
                                    ? '0 20px 60px rgba(244, 71, 71, 0.15)'
                                    : terminalState === 'typing'
                                        ? '0 20px 60px rgba(86, 156, 214, 0.15)'
                                        : '0 20px 60px rgba(0, 255, 136, 0.15)',
                                backgroundColor: '#1e1e1e',
                                height: '70vh',
                                transition: 'box-shadow 0.5s ease'
                            }}
                        >
                            {/* Window Title Bar */}
                            <div
                                className="flex items-center justify-between px-4 py-3"
                                style={{ backgroundColor: '#323233' }}
                            >
                                {/* Traffic Lights */}
                                <div className="flex items-center gap-2">
                                    <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#ff5f57' }} />
                                    <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#febc2e' }} />
                                    <div
                                        className="w-3 h-3 rounded-full"
                                        style={{
                                            backgroundColor: terminalState === 'error'
                                                ? '#febc2e'
                                                : terminalState === 'typing'
                                                    ? '#569cd6'
                                                    : '#28c840',
                                            transition: 'background-color 0.3s ease'
                                        }}
                                    />
                                </div>

                                {/* Window Title */}
                                <span className="text-[13px] font-medium" style={{ color: '#cccccc' }}>
                                    {terminalState === 'error'
                                        ? 'Terminal - Build Failed'
                                        : terminalState === 'typing'
                                            ? 'Terminal - Installing...'
                                            : 'Terminal - Build Success'}
                                </span>

                                {/* Spacer for centering */}
                                <div className="w-14" />
                            </div>

                            {/* Tab Bar */}
                            <div
                                className="flex items-center px-2"
                                style={{ backgroundColor: '#252526' }}
                            >
                                <div
                                    className="px-4 py-2 text-[12px] font-medium"
                                    style={{ backgroundColor: '#1e1e1e', color: '#ffffff' }}
                                >
                                    {terminalState === 'error'
                                        ? 'payments.ts'
                                        : terminalState === 'typing'
                                            ? 'payments.ts ⏳'
                                            : 'payments.ts ✓'}
                                </div>
                                <div
                                    className="px-4 py-2 text-[12px]"
                                    style={{ color: '#969696' }}
                                >
                                    build.log
                                </div>
                                <div className="flex-1" />
                            </div>

                            {/* Code Editor Area - All states are static for full reversibility */}
                            <div
                                className="relative flex-1"
                                style={{
                                    backgroundColor: '#0d0d0d',
                                    minHeight: 0,
                                    overflow: 'hidden'
                                }}
                            >
                                {/* Fixed-height viewport: content scrolls instead of stretching the mockup */}
                                <div className="h-full overflow-auto">
                                    {terminalState === 'error' && <ErrorTerminalContent />}
                                    {terminalState === 'typing' && <InstallingTerminalContent />}
                                    {terminalState === 'success' && <TypewriterSuccessContent />}
                                </div>

                                {/* Subtle scanline overlay for realism */}
                                <div
                                    className="absolute inset-0 pointer-events-none"
                                    style={{
                                        background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.01) 2px, rgba(255,255,255,0.01) 4px)'
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Right Panel - Text Area */}
                    <div
                        className="w-1/2 flex flex-col justify-center p-12 lg:p-16 lg:pl-20 bg-[#f5f4f0] dark:bg-[var(--pluckr-bg)]"
                    >
                        <div className="max-w-[480px] space-y-6">
                            <p
                                className="text-[40px] lg:text-[52px] font-bold leading-[1.05] tracking-[-0.02em] text-[#1a1a1a] dark:text-white"
                                style={{
                                    fontFamily: "'Lora', Georgia, serif"
                                }}
                            >
                                <span className="block whitespace-nowrap">Stop burning credits.</span>
                                <span
                                    className="block whitespace-nowrap"
                                    style={{
                                        textDecoration: 'underline',
                                        textDecorationColor: 'var(--pluckr-green)',
                                        textDecorationThickness: '2px',
                                        textUnderlineOffset: '4px'
                                    }}
                                >
                                    Start building.
                                </span>
                            </p>

                            <div className="pt-4 space-y-3">
                                <p
                                    className="text-[18px] lg:text-[20px] font-semibold tracking-[-0.01em]"
                                    style={{
                                        color: 'var(--pluckr-green)',
                                        fontFamily: "'Inter', sans-serif"
                                    }}
                                >
                                    Join waitlist
                                </p>

                                <form onSubmit={handleWaitlistSubmit}>
                                    <div
                                        className="w-full flex items-stretch h-[64px] rounded-full border overflow-hidden bg-white border-[#d7d7d7] dark:bg-[#282929] dark:border-white/15"
                                    >
                                        <input
                                            type="email"
                                            name="email"
                                            value={email}
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                                if (waitlistError) setWaitlistError('');
                                                if (waitlistSubmitted) setWaitlistSubmitted(false);
                                            }}
                                            placeholder="Your email address"
                                            required
                                            className="flex-1 min-w-0 h-full px-6 text-[15px] placeholder:opacity-60 text-[#1a1a1a] dark:text-white placeholder:text-[#b7bcc7] dark:placeholder:text-white/40"
                                            style={{
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                fontFamily: "'Inter', sans-serif",
                                                outline: 'none'
                                            }}
                                            aria-label="Email address"
                                        />
                                        <button
                                            type="submit"
                                            disabled={sourceStatus === 'loading'}
                                            className="h-full px-10 rounded-full bg-[#9be38f] text-[#1a1a1a] font-semibold leading-none hover:bg-[#8ad37f] transition-colors whitespace-nowrap disabled:opacity-60 disabled:hover:bg-[#9be38f]"
                                            style={{ fontFamily: "'Inter', sans-serif" }}
                                        >
                                            Join the waitlist
                                        </button>
                                    </div>
                                </form>

                                {waitlistSubmitted && (
                                    <p
                                        className="text-[14px] text-[#1a1a1a] dark:text-white/80"
                                        style={{
                                            fontFamily: "'Inter', sans-serif"
                                        }}
                                    >
                                        <span className="inline-flex items-center gap-2">
                                            <span className="font-semibold" style={{ color: 'var(--pluckr-green)' }}>✓</span>
                                            Joined waitlist. You will be informed soon.
                                        </span>
                                    </p>
                                )}

                                {!waitlistSubmitted && waitlistError ? (
                                    <p
                                        className="text-[14px] text-[#1a1a1a]/75 dark:text-white/60"
                                        style={{
                                            fontFamily: "'Inter', sans-serif"
                                        }}
                                    >
                                        {waitlistError}
                                    </p>
                                ) : null}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection2;
